import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/geobooster'

Styxie.Initializers.MobileWidgets = {
  index: async(props) => {
    const { default: WidgetsIndex } = await import('@/vue_widgets/geobooster/widgets/index.vue')
    createVueApp(WidgetsIndex, { props, sidebar })
  },

  edit: async(props) => {
    const { default: WidgetConfigurator } = await import('@/vue_widgets/geobooster/widgets/configurator/index.vue')
    // compact sidebar frees horizontal space for the form + live preview
    createVueApp(WidgetConfigurator, { props, sidebar })
  }
}
